<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps({
  title: { type: String, required: true },
  showBack: { type: Boolean, default: true },
})

defineEmits(['back'])
</script>

<template>
  <header class="page-header">
    <button v-if="showBack" type="button" class="btn-back" :aria-label="$t('common.back')" @click="$emit('back')">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        width="20"
        height="20"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </button>
    <h1 class="page-header__title">{{ title }}</h1>
    <div v-if="$slots.actions" class="page-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>
